module.exports = __webpack_public_path__ + "static/favicon-011b6d83876cf10c83cdc01550f516bc.ico";